"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlainCard = void 0;
var Utilities_1 = require("../../../Utilities");
var PlainCard_styles_1 = require("./PlainCard.styles");
var PlainCard_base_1 = require("./PlainCard.base");
exports.PlainCard = (0, Utilities_1.styled)(PlainCard_base_1.PlainCardBase, PlainCard_styles_1.getStyles, undefined, {
    scope: 'PlainCard',
});
//# sourceMappingURL=PlainCard.js.map